import React from "react";
import { Card, CardHeader, CardBody } from "reactstrap";

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const pageIconWrapStyle = {
  width: 32,
  height: 32,
  borderRadius: 8,
  border: "1px solid rgba(var(--vz-primary-rgb), 0.35)",
  background: "rgba(var(--vz-primary-rgb), 0.08)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const pageIconStyle = {
  color: "var(--vz-primary)",
  fontSize: 16,
};

const ConfigRow = ({ time, device, status }) => {

  const color =
    status === "Unauthorized"
      ? "#ef4444"
      : status === "Violation"
        ? "#f97316"
        : "#fde047";

  return (
    <div
      className="d-flex justify-content-between align-items-center mb-3"
      style={{
        borderBottom: "1px solid rgba(255,255,255,0.05)",
        paddingBottom: "6px"
      }}
    >
      <div>
        <small className="text-muted">{time}</small>
        <div>{device}</div>
      </div>

      <span
        style={{
          background: `rgba(${color === "#ef4444" ? "239,68,68" : color === "#f97316" ? "249,115,22" : "250,204,21"},0.15)`,
          color,
          fontSize: "11px",
          padding: "3px 10px",
          borderRadius: "999px",
          fontWeight: "600"
        }}
      >
        {status}
      </span>
    </div>
  );
};

const ConfigurationIntegrity = () => {
  return (
    <Card style={{ ...cardShell, border: "1px solid rgba(255,255,255,0.05)" }} className="h-100">

      <CardHeader className="bg-light d-flex justify-content-between align-items-center">
        <h5 className="card-title mb-0">
          <div style={pageIconWrapStyle} className="me-2">
            <i className="ri-settings-3-line" style={pageIconStyle} ></i>
          </div>
          Configuration & Integrity
        </h5>

        <button className="btn btn-sm btn-outline-light">
          View All
        </button>
      </CardHeader>

      <CardBody>

        <ConfigRow
          time="12:10"
          device="PLC_Line_A1"
          status="Authorized"
        />

        <ConfigRow
          time="11:45"
          device="HMI_Assembly_Main"
          status="Unauthorized"
        />

        <ConfigRow
          time="09:30"
          device="Safety_Controller_7"
          status="Violation"
        />

        <ConfigRow
          time="08:15"
          device="RTU_Remote_Site_B"
          status="Violation"
        />

      </CardBody>
    </Card>
  );
};

export default ConfigurationIntegrity;